import { useContext } from 'react'
import AuthContext from '@providers/AuthProvider'

export default function useAuth() {
  const AuthValues = useContext(AuthContext)

  return AuthValues
}
